/**
 * Image addresses from the API, ready for <img src>.
 *
 * Uploaded team logos and profile photos are served by the API itself and come
 * back as "/api/teams/12/logo?v=..." paths. The API is on another host than the
 * app, so those paths are put on the API's origin. Full https addresses, the
 * app's own paths (preset avatars) and inline images pass through; anything
 * else (e.g. a "javascript:" value) gives null.
 */
const apiOrigin = () => {
  const base =
    process.env.REACT_APP_API_URL ||
    (typeof window !== "undefined" && window.location?.hostname === "localhost" ? "http://localhost:5000/api" : "");
  try {
    return base ? new URL(base).origin : "";
  } catch {
    return "";
  }
};

export const mediaUrl = (value) => {
  if (typeof value !== "string") return null;
  const url = value.trim();
  if (!url) return null;
  if (url.startsWith("/api/")) return `${apiOrigin()}${url}`;
  if (url.startsWith("/") && !url.startsWith("//")) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (/^data:image\/(png|jpe?g|gif|webp|svg\+xml);/i.test(url)) return url;
  return null;
};

export default mediaUrl;
